import styles from "./index.module.scss"

interface BlockProps {
  title: string
  desc: string
  imgSrc: string
}

export const Block = (props: BlockProps) => {
  return (
    <div className={styles.Block}>
      <div className={styles.Left}>
        <img src={props.imgSrc} alt="Block icon"/>
        <div className={styles.StraightLine}/>
      </div>
      <div className={styles.Right}>
        <div className={styles.RightTitle}>{props.title}</div>
        <div>{props.desc}</div>
      </div>
    </div>
  )
}
